import { BadgeSharedProps } from "@certn/cascadia/components/badge/types";

import { _Badge } from "./_Badge";

export function NewBadge(props: BadgeSharedProps) {
  const {
    type = "bold",
    testID = "danger-badge",
    size = "large",
    padding,
    ...rest
  } = props;

  if (type === "bold")
    return (
      <_Badge
        fill="background-accent-purple-strong"
        color="text-accent-purple-weak"
        testID={testID}
        size={size}
        padding={padding}
        {...rest}
      />
    );

  return (
    <_Badge
      fill="background-accent-purple-weak"
      color="text-accent-purple-strong"
      testID={testID}
      size={size}
      padding={padding}
      {...rest}
    />
  );
}
